import React from "react";
// import { dashboard as section } from '../metadata.json';
import Notification from "../../Notification.tsx";
import DashboardViewer from "./Dashboard";
import CommentsView from "./../App/CommentsView";
import DashboardFilter from "./DashboardFilter";
import { preparefilter, replaceCommonFilters, showDashboard, extractFilterValues, prepareMultiFilter, cleanFilterParams } from "./DashboardUtils";
import { Button } from "react-bootstrap";
import DashboardEditorModal from "../Modals/DashboardEditorModal";
import DashboardEditor from "./dashboardEditor";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import exportFromJSON from "export-from-json";
import DashboardFilterViewer from "./DashboardFilterViewer";
import { Utils } from "../../helpers";
const fileName = "download";
const exportType = "xls";

class DashboardManager extends React.Component {
  constructor(props) {
    super(props);
    this.core = this.props.args;
    this.userProfile = this.core.make("oxzion/profile").get();
    this.filterRef = React.createRef();
    this.content = this.props.content;
    this.loader = this.core.make("oxzion/splash");
    this.alertAdapter = this.core?.make("oxzion/alert");
    this.filterLogic = "and";
    var uuid = "";
    if (this.props.uuid) {
      uuid = this.props.uuid;
    }
    if (this.props.content) {
      var content = this.props.content;
      if (content && content.uuid) {
        uuid = content.uuid;
      }
    }

    this.state = {
      showCommentsModal: false,
      tempStyles: {},
      showModal: false,
      modalType: "",
      modalContent: {},
      // flipped: false,
      dashListSelectData: [],
      uuid: uuid,
      dashList: [],
      inputs: {},
      dashboardBody: "",
      loadEditor: false,
      filterConfiguration: [],
      filterOptions: [],
      showFilter: false,
      dashboardFilter: content?.filter ? content.filter : [],
      drilldownDashboardFilter: content?.filter ? content.filter : [],
      hideEdit: this.props.hideEdit ? this.props.hideEdit : false,
      dashboardStack: [],
      dashboardStackDuplicate: content?.dashboardStack ? content?.dashboardStack : [],
      exportConfiguration: null,
      loadDefaultFilters: false,
      filterCount: 0,
      isEditing: false,
      linkedAppId: "",
    };
    this.appId = this.props.appId;
    this.appNavigationDiv = "navigation_" + this.appId;
    this.pageDiv = this.appId + "_pages";
    this.allFilters;
    this.proc = this.props.proc;
    this.refresh = React.createRef();
    this.notif = React.createRef();
    this.helper = this.core.make("oxzion/restClient");
    this.deleteDashboard = this.deleteDashboard.bind(this);
    this.myRef = React.createRef();
    this.defaultFilterConfig;
    this.extractedFilters;
    this.dashboardViewerActionButtons = [];
    this.dashboardBuilderActionButtons = [];
  }

  refreshDashboard = (e) => {
    if (this.state.dashboardStack.length > 0) {
      //!need to unmount in a different as here widgets are unmounting after it gets updated
      // document.getElementById(this.appNavigationDiv).dispatchEvent(new CustomEvent("unmountWidgets"))
      let event = {};
      let lastDasboardElement = this.state.dashboardStack[this.state.dashboardStack.length - 1];
      if (e.detail?.filters?.length > 0) {
        event.drilldownDashboardFilter = e.detail.filters;
      } else {
        event.drilldownDashboardFilter = lastDasboardElement.drilldownDashboardFilter;
      }
      event.value = JSON.stringify(lastDasboardElement.data);
      this.changeDashboard(event);
    }
  };

  init = () => {
    //initialising the customactions for dashboard
    const hasFilterConfiguration = Array.isArray(this.state.filterConfiguration) && this.state.filterConfiguration.length > 0;
    const hasFilterProperty = this.getFilterProperty("filterConfiguration")?.length > 0;
    const hasOptionalFilters = this.getOptionalFilters("filterOptions")?.length > 0;
    let containsFilter = hasFilterConfiguration || hasFilterProperty || hasOptionalFilters;
    let filterContainer = "filter-form-container-" + this.state.uuid;
    this.dashboardViewerActionButtons = [
      {
        icon: "fa fa-filter",
        title: "Filter OI",
        predefinedCallback: () => this.setShowFilter(!this.state.showFilter),
        content: this.state.filterCount > 0 ? <FilterCount count={this.state.filterCount} /> : " ",
        condition: containsFilter,
      },
      {
        icon: "fa fa-refresh",
        title: "Refresh OI",
        predefinedCallback: this.refreshDashboard,
        condition: document.getElementsByClassName(this.pageDiv)[0]?.childNodes.length <= 1,
      },
      {
        icon: "fa fa-comment",
        title: "Comments",
        predefinedCallback: () =>
          document.getElementById("navigation_" + this.props.appId).dispatchEvent(
            new CustomEvent("addPage", {
              detail: {
                pageContent: [
                  {
                    type: "Comment",
                    fileId: this.content.uuid,
                    commentType: "dashboard",
                  },
                ],
              },
              bubbles: true,
            }),
          ),
        condition: false,
      },
    ];
    this.dashboardBuilderActionButtons = [
      {
        icon: "fa-regular fa-plus",
        title: "Add New OI",
        onClick: this.createDashboard,
        condition: !this.props.hideEdit && this.userProfile.key.privileges.MANAGE_DASHBOARD_WRITE,
      },
      {
        icon: "fa-regular fa-edit",
        title: "Edit OI",
        onClick: this.editDashboard,
        condition: this.userProfile.key.privileges.MANAGE_DASHBOARD_WRITE,
      },
      {
        icon: "fa-regular fa-trash",
        title: "Delete OI",
        onClick: () => this.dashboardOperation(this.state.inputs["dashname"], "Delete"),
        condition: this.userProfile.key.privileges.MANAGE_DASHBOARD_DELETE,
      },
      {
        icon: "fa-regular fa-filter",
        title: "Filter OI",
        onClick: () => this.setShowFilter(!this.state.showFilter),
        condition: containsFilter,
        badge: this.state.filterCount > 0 ? this.state.filterCount : null,
      },
      {
        icon: "fa-regular fa-file-export",
        title: "Export OI",
        onClick: this.exportExcel,
        condition: this.state.exportConfiguration !== null && this.state.exportConfiguration !== "",
      },
      {
        icon: "fa-regular fa-home-heart",
        title: "Make Current OI as Default",
        onClick: () => this.dashboardOperation(this.state.inputs["dashname"], "SetDefault"),
        condition:
          this.userProfile.key.privileges.MANAGE_DASHBOARD_WRITE &&
          this.state.inputs["dashname"] != undefined &&
          this.state.inputs["dashname"]["isdefault"] == "0",
      },
      {
        icon: "fa-regular fa-clone",
        title: "Clone selected Dashboard",
        onClick: () => this.cloneDashboard(this.state.inputs["dashname"]),
        condition: this.userProfile.key.privileges.MANAGE_DASHBOARD_WRITE && this.state.inputs["dashname"] != undefined,
      },
    ];
  };

  componentDidUpdate(prevProps, prevState) {
    // Only regenerate action buttons when filter configuration changes or after stepDownPage
    const filterConfigChanged = JSON.stringify(prevState.filterConfiguration) !== JSON.stringify(this.state.filterConfiguration);
    const uuidChanged = prevState.uuid !== this.state.uuid;
    const filterCountChanged = prevState.filterCount !== this.state.filterCount;

    if (filterConfigChanged || uuidChanged || filterCountChanged) {
      this.init();
      this.generateCustomActions(this.dashboardViewerActionButtons);
    }
  }

  componentDidMount() {
    this.init();
    this.generateCustomActions(this.dashboardViewerActionButtons);

    const customEvents = {
      rollupToDashboard: () => {
        var that = this;
        that.rollupToDashboard();
      },
      getDashboardHtmlDataByUuid: (e) => {
        var that = this;
        that.getDashboardHtmlDataByUuid(e.detail.uuid);
      },
      handleOIRefresh: this.refreshDashboard,
    };

    for (const key in customEvents) {
      document.getElementById(this.appNavigationDiv)?.addEventListener(key, customEvents[key], false);
    }

    if (this.props.uuid && this.props.uuid != "" && this.props.uuid != 0) {
      this.getDashboardHtmlDataByUuid(this.props.uuid);
    } else {
      this.fetchDashboards(false);
    }
    this.myRef.current.scrollTo(100, 100);
    if (this.filterRef.current && this.filterRef.current.state.applyFilterOption) {
      this.setState({
        filterOptions: this.filterRef.current.state.applyFilterOption,
      });
    }
  }

  dispatchGenerateBreadcrumbs = (drilldownDashboardFilter) => {
    let ev = new CustomEvent("generateBreadCrumbs", {
      detail: {
        data: [
          ...this.state.dashboardStack.map((stack) => ({
            ...stack,
            drilldownDashboardFilter,
            type: "dashboard",
          })),
        ],
        drilldownDashboardFilter,
      },
    });
    if (document.getElementById(this.appNavigationDiv)) {
      document.getElementById(this.appNavigationDiv).dispatchEvent(ev);
    }
  };

  async getUserDetails(uuid) {
    let rolesList = await this.helper.request("v1", "organization/" + this.props.selectedOrg + "/user/" + uuid + "/profile", {}, "get");
    return rolesList;
  }

  dashboardOperation = (e, operation) => {
    if (operation === "Delete" || operation === "Activate" || operation === "SetDefault") {
      this.setState({ showModal: true, modalContent: e, modalType: operation });
    } else {
      this.setState({
        showModal: true,
        modalContent: e,
        modalType: operation,
        uuid: e.uuid,
      });
    }
  };

  cloneDashboard(selectedDash) {
    const { uuid } = selectedDash;
    let cloneWidgets = false;
    let cloneQueries = false;
    let cloneTemplates = false;
    this.alertAdapter
      ?.show({
        title: "Clone Dashboard Options",
        htmlContent: `
      <div class="container">
        <div class="row mb-2">
          <div class="col-12">
            <div class="form-check d-flex align-items-center">
              <input class="form-check-input me-2" type="checkbox" id="cloneWidgets">
              <label class="form-check-label h5" for="cloneWidgets">Clone Widgets?</label>
            </div>
          </div>
        </div>
        
        <div class="row mb-2">
          <div class="col-12">
            <div class="form-check d-flex align-items-center">
              <input class="form-check-input me-2" type="checkbox" id="cloneQueries">
              <label class="form-check-label h5" for="cloneQueries">Clone Queries?</label>
            </div>
          </div>
        </div>
        
        <div class="row mb-2">
          <div class="col-12">
            <div class="form-check d-flex align-items-center">
              <input class="form-check-input me-2" type="checkbox" id="cloneTemplates">
              <label class="form-check-label h5" for="cloneTemplates">Clone Templates?</label>
            </div>
          </div>
        </div>
      </div>`,
        cancelButtonText: "No, cancel",
        confirmButtonText: "Yes, clone it!",
        allowOutsideClick: false,
        preConfirm: () => {
          cloneWidgets = document.getElementById("cloneWidgets").checked;
          cloneQueries = document.getElementById("cloneQueries").checked;
          cloneTemplates = document.getElementById("cloneTemplates").checked;
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          return this.helper.request(
            "v1",
            `dashboard/${uuid}/clone`,
            {
              cloneWidgets: cloneWidgets,
              cloneQueries: cloneQueries,
              cloneTemplates: cloneTemplates,
            },
            "post",
          );
        }
        return Promise.reject("Clone cancelled");
      })
      .then((response) => {
        this.alertAdapter?.show({
          title: "Dashboard cloned successfully!",
          htmlContent: `<h5>Dashboard created with the name <strong>${response.data.newDashboardDetails.name}</strong></h5>`,
          confirmButtonText: "Got it",
          icon: "success",
        });
        this.fetchDashboards(true);
      })
      .catch((error) => {
        if (error === "Clone cancelled") {
          return;
        }
        console.error(error);
      });
  }

  async getDashboardHtmlDataByUuid(uuid) {
    // let dashboardStack = [...this.state.dashboardStack]
    let dashboardStack = JSON.parse(JSON.stringify(this.state.dashboardStack));
    let inputs = this.state.inputs !== undefined ? this.state.inputs : undefined;
    let dashData = [];
    let response = await this.helper.request("v1", "analytics/dashboard/" + uuid, {}, "get");
    let dash = response.data.dashboard;
    let filterOptions = [];
    let filterConfig = dash?.filter_configuration != "" ? JSON.parse(dash.filter_configuration) : [];
    dashData.push({ dashData: response.data });
    filterConfig =
      filterConfig &&
      filterConfig.map((filter, index) => {
        let updatedFilter = {
          ...filter,
          uuid: Utils.generateUUID(),
        };
        if (!filter.isDefault) {
          filterOptions.push({ label: filter["filterName"], value: filter });
        }
        return updatedFilter;
      });

    inputs["dashname"] = dash;
    let drilldownDashboardFilter;
    // FIX: originalDrilldownFilter should only contain external context filters (from navigation/drilldown),
    // NOT the default filter values. Default filters should be replaceable by user, not concatenated.
    let originalDrilldownFilter = this.props.content?.filter?.length > 0 ? this.props.content.filter : [];
    if (this.props.content?.filter?.length > 0) {
      const defaultFilters = this.getPreparedExtractedFilterValues(filterConfig, "default");
      drilldownDashboardFilter = [
        ...(defaultFilters?.length > 0 ? [defaultFilters] : []),
        ...(defaultFilters?.length > 0 ? ["AND"] : []),
        this.props.content?.filter,
      ];
    } else {
      drilldownDashboardFilter = this.getPreparedExtractedFilterValues(filterConfig, "default");
    }
    const dashboardStackItem = {
      data: dash,
      drilldownDashboardFilter: drilldownDashboardFilter,
      // originalDrilldownFilter: drilldownDashboardFilter,
      originalDrilldownFilter: originalDrilldownFilter,
    };
    if (this.props.content && this.props.content.widgetFilter) {
      dashboardStackItem.widgetFilter = this.props.content.widgetFilter;
    }
    dashboardStack.push(dashboardStackItem);
    this.defaultFilterConfig = filterConfig;
    this.setState(
      {
        dashboardBody: "",
        inputs,
        uuid: uuid,
        dashList: dashData,
        filterConfiguration: filterConfig,
        dashboardStack: dashboardStack,
        exportConfiguration: dash.export_configuration,
        drilldownDashboardFilter: drilldownDashboardFilter,
        filterOptions: filterOptions,
        loadDefaultFilters: true,
        filterCount: filterConfig.length - filterOptions.length,
        linkedAppId: response.data["app_id"] || "",
      },
      () => {
        let breadcrumbFilters;
        const getFilterIfPresent = (filter) => (filter && filter.length > 0 ? filter : []);

        const widgetFilter = getFilterIfPresent(this.state.dashboardStack[0].widgetFilter);
        const drilldownFilter = getFilterIfPresent(this.state.dashboardStack[0].drilldownDashboardFilter);

        const widgetFilterStr = JSON.stringify([widgetFilter]);
        const drilldownFilterStr = JSON.stringify(drilldownFilter);

        if (widgetFilterStr !== drilldownFilterStr) {
          breadcrumbFilters = [widgetFilter, ...(widgetFilter.length && drilldownFilter.length ? ["AND"] : []), drilldownFilter];
        } else {
          breadcrumbFilters = [widgetFilter];
        }

        // const breadcrumbFilters = [widgetFilter, ...(widgetFilter.length && drilldownFilter.length ? ["AND"] : []), drilldownFilter];
        this.dispatchGenerateBreadcrumbs(breadcrumbFilters);
        // this.dispatchGenerateBreadcrumbs([this.state.dashboardStack[0].widgetFilter, "AND", this.state.dashboardStack[0].drilldownDashboardFilter]);
      },
    );
  }

  async fetchDashboards(isRefreshed) {
    let that = this;
    let filterOptions = [];
    let inputs = this.state.inputs !== undefined ? this.state.inputs : undefined;
    let dashboardStack = !isRefreshed ? [] : JSON.parse(JSON.stringify(this.state.dashboardStack)); //Contains everything that is part of a dashboard (Including the data and filter)
    let response = await this.helper.request(
      "v1",
      '/analytics/dashboard?filter=[{"sort":[{"field":"name","dir":"asc"}],"skip":0,"take":0}]',
      {},
      "get",
    );
    if (response.data.length > 0) {
      let dashList = response.data.map((item) => ({
        value: JSON.stringify(item),
        label: item.name,
        key: item.uuid,
      }));
      that.setState({
        dashList: dashList,
        dashListSelectData: dashList,
        uuid: "",
      });
      if (inputs["dashname"] != undefined) {
        //Checking to see if the dashboard is edited or refreshed
        //setting value of the dropdown after fetch
        response.data.map((dash) => {
          if (dash.name === inputs["dashname"]["name"]) {
            //Checking to see if the dashboard in the list matches the edited dashboard
            let filterConfig = dash.filter_configuration != "" ? JSON.parse(dash.filter_configuration) : [];
            inputs["dashname"] = dash;
            let drilldownDashboardFilter = this.getPreparedExtractedFilterValues(filterConfig, "default");
            if (!isRefreshed) {
              dashboardStack.push({
                data: dash,
                drilldownDashboardFilter: drilldownDashboardFilter,
                filterConfiguration: filterConfig,
              });
            } else {
              if (dashboardStack.length > 0) {
                let appliedFilters = [];
                // filterConfig && optionalFilter;
                filterConfig.map((filter, index) => {
                  if (!filter.isDefault) {
                    filterOptions.push({
                      label: filter["filterName"],
                      value: filter,
                    });
                  } else {
                    appliedFilters.push(filter);
                  }
                });
                let dashboardStackLen = dashboardStack.length - 1;
                //replacing with new filter values after dashboard edit
                dashboardStack[dashboardStackLen]["filterConfiguration"] = appliedFilters;
                dashboardStack[dashboardStackLen]["filterOptions"] = filterOptions;
                dashboardStack[dashboardStackLen]["drilldownDashboardFilter"] = drilldownDashboardFilter;
                dashboardStack[dashboardStackLen]["data"] = dash;
              }
            }
            that.setState({
              inputs,
              uuid: dash.uuid,
              filterConfiguration: filterConfig,
              exportConfiguration: dash.export_configuration,
              dashboardStack: dashboardStack,
              filterOptions: filterOptions,
            });
            isRefreshed &&
              that.setState({
                drilldownDashboardFilter: drilldownDashboardFilter,
              });
          } else {
            that.setState({
              inputs: this.state.inputs,
              filterCount: this.state.filterConfiguration.filter((v) => v.isDefault).length,
            });
          }
        });
      } else {
        //setting default dashboard on page load
        response.data.map((dash) => {
          if (dash.isdefault === 1) {
            let filterConfig = dash.filter_configuration != "" ? JSON.parse(dash.filter_configuration) : [];
            inputs["dashname"] = dash;
            let filterOptions = [];
            filterConfig &&
              filterConfig.map((filter, index) => {
                if (!filter.isDefault) {
                  filterOptions.push({
                    label: filter["filterName"],
                    value: filter,
                  });
                }
              });
            let drilldownDashboardFilter = this.getPreparedExtractedFilterValues(filterConfig, "default");
            !isRefreshed &&
              dashboardStack.push({
                data: dash,
                drilldownDashboardFilter: drilldownDashboardFilter,
                // originalDrilldownFilter: drilldownDashboardFilter, // Store original filters separately
                // FIX: originalDrilldownFilter should only contain external context, not default filters
                originalDrilldownFilter: [],
                filterConfiguration: filterConfig,
                filterOptions: filterOptions,
              });

            that.setState({
              dashboardBody: "",
              inputs,
              uuid: dash.uuid,
              exportConfiguration: dash.export_configuration,
              filterConfiguration: filterConfig,
              dashboardStack: dashboardStack,
              drilldownDashboardFilter: drilldownDashboardFilter,
              filterOptions: filterOptions,
              loadDefaultFilters: true,
            });
          }
        });
      }
    } else {
      this.setState({ dashboardBody: "NO OI FOUND" });
    }
  }

  getPreparedExtractedFilterValues(dashboardFilter, filtermode) {
    filtermode = filtermode || "applied";
    let extractedFilterValues = extractFilterValues(dashboardFilter, [...this.state.dashboardStack], filtermode);
    let preapredExtractedFilterValue = null;
    if (extractedFilterValues && extractedFilterValues.length > 0) {
      preapredExtractedFilterValue = extractedFilterValues[0];
      for (let i = 1; i < extractedFilterValues.length; i++) {
        preapredExtractedFilterValue = preparefilter(preapredExtractedFilterValue, extractedFilterValues[i]);
      }
    }
    return preapredExtractedFilterValue;
  }

  setTitle = (title) => {
    this.setState({ title: title });
  };

  deleteDashboard = () => {
    let inputs = { ...this.state.inputs };
    if (inputs["dashname"] != undefined) {
      inputs["dashname"] = undefined;
      this.setState({ inputs: {} });
    }
  };

  editDashboard = () => {
    showDashboard(true);
    this.setState({ isEditing: true, uuid: this.state.uuid, loadEditor: true });
  };

  createDashboard = () => {
    showDashboard(true);
    let inputs = { ...this.state.inputs };
    inputs["dashname"] !== undefined && delete inputs.dashname;
    this.setState({
      isEditing: true,
      uuid: "",
      inputs: inputs,
      loadEditor: true,
    });
  };

  showCommentsModal = (dashboardUuid) => {
    this.setState({ showCommentsModal: true }, (state) => {
      let commentsContainer = "comments-modal-container-" + dashboardUuid;
      let filterPreview = "dashboard-preview-container-" + dashboardUuid;
      var element = document.getElementById(commentsContainer);
      element.classList.remove("disappear");
      element.classList.add("show-filter-panel");
      var element = document.getElementById(filterPreview);
      // element.classList.add("disappear");
      element.classList.add("blurOut");
    });
  };

  hideFilter = () => {
    let filterPreview = "dashboard-preview-container-" + this.state.uuid;
    this.setState({ showFilter: false });
    var element = document.getElementById(filterPreview);
    element.classList.remove("blurOut");
  };

  hideCommentsModal = () => {
    let filterPreview = "dashboard-preview-container-" + this.state.uuid;
    this.setState({ showCommentsModal: false });
    var element = document.getElementById(filterPreview);
    element.classList.remove("blurOut");
  };

  applyDashboardFilter = (filter) => {
    let dashboardStack = null;
    let dashboardFilterRef = this.filterRef.current;
    let filterOptions = dashboardFilterRef.state.applyFilterOption;
    this.setState({
      filterCount: filter.length,
    });
    if (this.state.dashboardStack.length == 1) {
      dashboardStack = [...this.state.dashboardStack];
      let dashboardFilter = filter;
      let extractedFilterValues = extractFilterValues(dashboardFilter, dashboardStack);
      // Clean extracted filter values before processing
      let cleanedExtractedFilterValues = cleanFilterParams(extractedFilterValues) || [];
      let drilldownDashboardFilter = cleanedExtractedFilterValues.length == 1 ? cleanedExtractedFilterValues[0] : [];
      if (cleanedExtractedFilterValues.length > 1) {
        drilldownDashboardFilter = cleanedExtractedFilterValues[0];
        drilldownDashboardFilter = prepareMultiFilter(drilldownDashboardFilter);
        for (let i = 1; i < cleanedExtractedFilterValues.length; i++) {
          drilldownDashboardFilter = preparefilter(drilldownDashboardFilter, cleanedExtractedFilterValues[i]);
        }
      }
      dashboardStack[dashboardStack.length - 1]["drilldownDashboardFilter"] = drilldownDashboardFilter;
      dashboardStack[dashboardStack.length - 1]["filterConfiguration"] = filter;
      dashboardStack[dashboardStack.length - 1]["filterOptions"] = filterOptions;
    }
    if (dashboardStack != null) {
      this.setState({
        dashboardFilter: filter,
        dashboardStack: dashboardStack,
        filterConfiguration: filter,
        filter,
        filterOptions: filterOptions,
      });
    } else {
      this.setState({
        dashboardFilter: filter,
        filterConfiguration: filterOptions,
        filterOptions: filterOptions,
      });
    }
    this.setShowFilter(false);
  };

  getDashboardFilters = () => {
    if (this.state.filterConfiguration) {
      try {
        let validJson = JSON.parse(this.state.filterConfiguration);
        return validJson;
      } catch (e) {
        console.error("Invalid json filter found in the database");
        return [];
      }
    } else {
      return [];
    }
  };

  drilldownToDashboard = (e, type) => {
    //pushing next dashboard details into dashboard stack
    let dashboardStack = JSON.parse(JSON.stringify(this.state.dashboardStack));
    let filterConfiguration = this.filterRef.current;
    let dashboardTitle = e.drilldownDashboardTitle ? e.drilldownDashboardTitle : "";
    document.getElementById(this.appNavigationDiv)?.dispatchEvent(new CustomEvent("unmountWidget"));
    //adding applied filters on dashboard
    if (dashboardStack.length > 0) {
      dashboardStack[dashboardStack.length - 1]["drilldownDashboardFilter"] = e.drilldownDashboardFilter ? e.drilldownDashboardFilter : [];
      //filter which are applied on the dashboard
      dashboardStack[dashboardStack.length - 1]["filterConfiguration"] =
        filterConfiguration && filterConfiguration.state.filters ? filterConfiguration.state.filters : [];
      //filters which appear in drop down
      dashboardStack[dashboardStack.length - 1]["filterOptions"] = this.getOptionalFilters("filterOptions");
      dashboardStack[dashboardStack.length - 1]["widgetFilter"] = e.widgetFilter ? e.widgetFilter : [];
    }
    let value = JSON.parse(e.value);

    // Clean drilldown filter before adding to stack
    let cleanedDrilldownFilter = cleanFilterParams(e.drilldownDashboardFilter) || [];
    if (dashboardStack.length > 1) {
      //check for consequent drilldown to same dashboard
      if (dashboardStack[dashboardStack.length - 1]["data"]["uuid"] != value["uuid"])
        dashboardStack.push({
          data: value,
          drilldownDashboardFilter: cleanedDrilldownFilter,
          originalDrilldownFilter: cleanedDrilldownFilter, // Store original filters separately
          drilldownDashboardTitle: dashboardTitle,
          widgetFilter: e.widgetFilter ? e.widgetFilter : [],
        });
    } else {
      dashboardStack.push({
        data: value,
        drilldownDashboardFilter: cleanedDrilldownFilter,
        originalDrilldownFilter: cleanedDrilldownFilter, // Store original filters separately
        drilldownDashboardTitle: dashboardTitle,
        widgetFilter: e.widgetFilter ? e.widgetFilter : [],
      });
    }
    this.setState({ loadDefaultFilters: false }, () => {
      // this.changeDashboard(e);
      const [uuid, title, drilldownDashboardFilter, widgetFilter] = [
        dashboardStack[dashboardStack.length - 1].data.uuid,
        dashboardStack[dashboardStack.length - 1].data.name,
        dashboardStack[dashboardStack.length - 1].drilldownDashboardFilter,
        dashboardStack[dashboardStack.length - 1].widgetFilter,
      ];
      const ev = new CustomEvent("addPage", {
        detail: {
          pageId: uuid + "_temppage",
          pageContent: [
            {
              content: { uuid: uuid, filter: drilldownDashboardFilter, widgetFilter, dashboardStack: dashboardStack },
              name: title,
              title: title,
              type: "DashboardManager",
            },
          ],
        },
        bubbles: true,
      });
      if (document.getElementById(this.appNavigationDiv)) {
        document.getElementById(this.appNavigationDiv).dispatchEvent(ev);
        this.dispatchGenerateBreadcrumbs(drilldownDashboardFilter);
      }
    });
  };

  changeDashboard = (event) => {
    //defining change dashboard explicitly to support reset dashboard on handle change
    let inputs = {};
    inputs = { ...this.state.inputs };
    let value;
    showDashboard(false);
    value = JSON.parse(event.value);
    let filterConfig = value["filter_configuration"] != "" ? JSON.parse(value["filter_configuration"]) : [];
    inputs["dashname"] = value;
    let optionalFilter = [];
    if (this.state.dashboardStack.length > 1) {
      optionalFilter = replaceCommonFilters(
        [...this.state.dashboardStack[this.state.dashboardStack.length - 2]["filterConfiguration"]],
        filterConfig,
        "filterOptions",
      );
      this.setState({ filterOptions: optionalFilter });
    }
    this.setState(
      {
        inputs: inputs,
        uuid: value["uuid"],
        filterConfiguration: filterConfig,
        showFilter: false,
        filter: [],
        dashboardFilter: [],
        drilldownDashboardFilter: event.drilldownDashboardFilter,
      },
      () => {
        this.dashboardViewerRef.updateGraphWithFilterChanges(true);
        // this.init()
        // this.generateCustomActions(this.dashboardViewerActionButtons);
      },
    );
  };

  handleChange = (event, inputName) => {
    let inputs = {};
    inputs = { ...this.state.inputs };
    let name;
    let value;
    let filterOptions = [];
    // resetting stack on manual change of dashboard
    let dashboardStack = [];
    value = JSON.parse(event.value);
    if (inputName && inputName == "dashname") {
      showDashboard(false);
      name = inputName;
      value = JSON.parse(event.value);
      //resetting dashboard filters on load
      let dashboardFilterConf = value["filter_configuration"] != "" ? JSON.parse(value["filter_configuration"]) : [];
      this.setState({
        dashboardFilter: dashboardFilterConf,
        exportConfiguration: value.export_configuration,
      });
    } else {
      name = event.target.name;
      value = event.target.value;
    }
    inputs[name] = value;
    let dashboardFilter = value["filter_configuration"] != "" ? JSON.parse(value["filter_configuration"]) : [];
    let extractedFilterValues = extractFilterValues(dashboardFilter, [...this.state.dashboardStack], "default");
    let preapredExtractedFilterValue = null;

    dashboardFilter &&
      dashboardFilter.map((filter, index) => {
        if (!filter.isDefault) {
          filterOptions.push({
            label: filter["filterName"],
            value: filter,
          });
        }
      });

    if (dashboardStack.length != 0) {
      if (extractedFilterValues && extractedFilterValues.length > 1) {
        preapredExtractedFilterValue = extractedFilterValues[0];
        for (let i = 1; i < extractedFilterValues.length; i++) {
          let extractFilter = extractedFilterValues[i];
          extractedMultiFilters = prepareMultiFilter(extractFilter);
          preapredExtractedFilterValue = preparefilter(preapredExtractedFilterValue, extractedMultiFilters);
        }
      }
    }
    dashboardStack.push({
      data: value,
      drilldownDashboardFilter: preapredExtractedFilterValue,
      // originalDrilldownFilter: preapredExtractedFilterValue, // Store original filters separately
      // FIX: originalDrilldownFilter should only contain external context, not default filters
      originalDrilldownFilter: [],
      filterConfiguration: dashboardFilter,
    });
    this.setState(
      {
        inputs: inputs,
        uuid: value["uuid"],
        filterConfiguration: dashboardFilter,
        showFilter: false,
        filter: dashboardFilter,
        drilldownDashboardFilter: event.drilldownDashboardFilter,
        dashboardStack: dashboardStack,
        loadDefaultFilters: true,
        filterOptions: filterOptions,
      },
      () => {
        // console.log(this.state);
      },
    );
  };

  //not needed
  rollupToDashboard = () => {
    if (this.state.dashboardStack.length > 1) {
      this.setState(
        (prevState) => ({
          dashboardStack: prevState.dashboardStack.slice(0, -1),
          loadDefaultFilters: false,
        }),
        () => {
          if (this.state.dashboardStack.length > 0) {
            let event = {};
            let lastDasboardElement = this.state.dashboardStack[this.state.dashboardStack.length - 1];
            event.value = JSON.stringify(lastDasboardElement.data);
            event.drilldownDashboardFilter = lastDasboardElement.drilldownDashboardFilter;
            // document.getElementById(this.appNavigationDiv).dispatchEvent(new CustomEvent("stepDownOneBreadCrumb"));
            this.changeDashboard(event);
          }
        },
      );
    } else {
      document.getElementById(this.appNavigationDiv).dispatchEvent(new CustomEvent("stepDownPage"));
    }
  };

  getFilterProperty = (property) => {
    let appliedFilters = [];
    if (this.state.dashboardStack && this.state.dashboardStack.length > 0) {
      if (this.state.dashboardStack[this.state.dashboardStack.length - 1][property]) {
        //executes after the filter is applied in the drilldown dashboard [filterconfiguration in dashboardstack must be set]
        return this.state.dashboardStack[this.state.dashboardStack.length - 1][property];
      } else if (this.state.dashboardStack.length > 1) {
        appliedFilters = replaceCommonFilters(
          [...this.state.dashboardStack[this.state.dashboardStack.length - 2][property]],
          [...this.state[property]],
          property,
        );
        return appliedFilters;
      } else return this.state[property];
    }
    return this.state[property];
  };

  getOptionalFilters = (property) => {
    if (this.state.dashboardStack && this.state.dashboardStack.length > 0) {
      if (this.state.dashboardStack[this.state.dashboardStack.length - 1][property]) {
        return this.state.dashboardStack[this.state.dashboardStack.length - 1][property];
      } else if (this.state.dashboardStack.length > 1) {
        let childfilter = [];
        if (this.state.filterOptions && this.state.filterOptions.length > 0) {
          childfilter = [...this.state.filterOptions];
        }
        let optionalFilter = replaceCommonFilters(
          [...this.state.dashboardStack[this.state.dashboardStack.length - 2]["filterConfiguration"]],
          childfilter,
          property,
        );
        return optionalFilter;
      } else return [...this.state[property]];
    }
    return [...this.state[property]];
  };

  async exportExcel() {
    let formData = {};
    if (this.state.exportConfiguration != null) {
      let parsedConfiguration = JSON.parse(this.state.exportConfiguration);
      formData["configuration"] = JSON.stringify(parsedConfiguration["configuration"]);
      formData["datasource_id"] = parsedConfiguration["datasource_id"];
      formData["filter"] = JSON.stringify(this.state.DashboardFilter);
    }
    let response = await this.helper.request("v1", "analytics/query/preview", formData, "filepost");
    this.notif.current.notify("Generating Report", "Please wait...", "warning");
    if (response.status == "success") {
      let data = response.data.result;
      let filename = this.state.inputs["dashname"]["name"];
      exportFromJSON({ data, fileName: filename, exportType });
    } else {
      this.notif.current.notify("Could not fetch data", "Please check the export configuration", "error");
    }
  }

  setShowFilter = (bool) => {
    this.setState({ showFilter: bool });
  };

  //merging the array or objects together into an array that has with no duplicates
  mergingFilters = (arr1, arr2) => {
    const combinedArray = [...arr1, ...arr2];
    const uniqueSet = new Set();

    return combinedArray.filter((obj) => {
      if (!uniqueSet.has(obj.field)) {
        uniqueSet.add(obj.field);
        return true;
      }
      return false;
    });
  };

  applyFiltersFromViewer = (extractedFilters, newFilterConfiguration, allFilters, filterLogic) => {
    this.filterLogic = filterLogic;
    let dashboardStack = [...this.state.dashboardStack];

    const lastDashboard = dashboardStack[dashboardStack.length - 1];

    // Get base filters that should be preserved (navigation/drilldown filters, not user-applied filters)
    // These come from the original dashboard configuration or navigation context
    const originalDrilldown = lastDashboard?.originalDrilldownFilter || [];
    const hasWidgetFilter = this.content?.widgetFilter?.length > 0;

    // Decide base filter: prefer original drilldown; if none and widget filter exists, use widget filter
    // This should NOT include user-applied filters from the filter viewer
    let baseFilter = [];
    if (originalDrilldown?.length > 0) {
      baseFilter = originalDrilldown;
    } else if (hasWidgetFilter) {
      baseFilter = this.content.widgetFilter;
    }

    // Merge extracted (viewer-applied) filters with base filter
    let finalFilter;

    // If no filters are applied (extractedFilters is empty or null), clear all filters
    if (!extractedFilters || extractedFilters.length === 0) {
      // Only keep base filters if they exist and no viewer filters are applied
      // This ensures that when user removes all filters, we clear the viewer-applied filters
      // but preserve any base filters (like drilldown filters from navigation)
      finalFilter = baseFilter;
    } else if (baseFilter?.length > 0 && extractedFilters?.length > 0) {
      finalFilter = preparefilter(baseFilter, extractedFilters);
    } else if (baseFilter?.length > 0) {
      finalFilter = baseFilter;
    } else {
      finalFilter = extractedFilters;
    }

    // Clean final filter to avoid empty arrays
    const cleanedFinalFilter = cleanFilterParams(finalFilter) || [];

    lastDashboard.drilldownDashboardFilter = cleanedFinalFilter;
    lastDashboard.filterConfiguration = newFilterConfiguration;
    lastDashboard.filterOptions = allFilters;

    this.setState({
      dashboardFilter: newFilterConfiguration,
      dashboardStack,
      filter: newFilterConfiguration,
      filterOptions: allFilters,
    });
    this.extractedFilters = cleanedFinalFilter;
    this.setShowFilter(false);
  };

  generateCustomActions = (incomingCustomActions) => {
    document.getElementById(this.appNavigationDiv)?.dispatchEvent(
      new CustomEvent("setOperationButtons", {
        detail: {
          operationButtons: incomingCustomActions.filter((actionButtonObj) => actionButtonObj.condition),
          eventOrigin: "DashboardManager",
        },
      }),
    );
  };

  getViewer = (oiStudio) => {
    const commentsContainer = "comments-modal-container-" + this.state.uuid;
    const filterPreview = "dashboard-preview-container-" + this.state.uuid;
    const rollUpDiv = "dashboard-rollup-button-" + this.state.uuid;

    const dashboardHeaderWithDropDown = (
      <div className="dashboard-header-container">
        <div className="dashboard-label-text">
          <div id={rollUpDiv} className="dashboard-rollup-button">
            {JSON.stringify(this.state.inputs["dashname"]) !== undefined ? this.state.inputs["dashname"]["name"] : "Select OI"}
          </div>
        </div>
        <div className="dash-manager-bar" style={{ paddingTop: "2px !important" }}>
          <DropDownList
            defaultItem={
              JSON.stringify(this.state.inputs["dashname"]) !== undefined
                ? {
                    value: this.state.inputs["dashname"],
                    label: this.state.inputs["dashname"]["name"],
                  }
                : {
                    value: null,
                    label: "Select OI",
                  }
            }
            popupSettings={{
              className: "analytics-dashboard-select-dropdown",
            }}
            className="analytics-dashboard-select-dropdown"
            data={this.state.dashListSelectData}
            textField="label"
            filterable={true}
            onChange={(e) => this.handleChange(e.value, "dashname")}
            onFilterChange={(event) => {
              this.setState({
                dashListSelectData: filterBy(this.state.dashList, event.filter),
              });
            }}
            style={{
              width: "300px",
            }}
          />
          {oiStudio &&
            this.dashboardBuilderActionButtons
              .filter((each) => each.condition)
              .map((each) => {
                const { onClick, title, icon, content } = each;
                return (
                  <Button onClick={onClick} title={title}>
                    <i className={icon} aria-hidden="true"></i>
                    {content && content}
                  </Button>
                );
              })}
        </div>
      </div>
    );

    return (
      <>
        {this.state.showFilter && (
          <>
            <div
              onClick={() => this.setShowFilter(false)}
              style={{
                position: "fixed",
                top: 50,
                zIndex: 10,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0)",
                backdropFilter: "blur(10px)",
              }}
            ></div>
            <div className="filter-form-container">
              <DashboardFilterViewer
                filterLogic={this.filterLogic}
                loader={this.loader}
                restClient={this.helper}
                filterConfiguration={this.getFilterProperty("filterConfiguration")}
                applyFiltersFromViewer={this.applyFiltersFromViewer}
                allFilters={this.mergingFilters(
                  this.state.filterConfiguration,
                  this.state.filterOptions
                    .filter((filterOption) => filterOption.value && typeof filterOption === "object")
                    .map((filterOptions) => filterOptions.value),
                )}
                setShowFilter={this.setShowFilter}
                filterCount={this.state.filterCount}
                setFilterCount={(count) => {
                  this.setState({ filterCount: count });
                }}
                appNavigationDiv={this.appNavigationDiv}
              />
            </div>
          </>
        )}
        {this.state.showCommentsModal && (
          <div id={commentsContainer} style={{ width: "50vw" }} className="comments-modal-container disappear">
            <div className="dash-manager-buttons">
              <Button
                type="button"
                className="close"
                style={{
                  fontSize: "1.5rem",
                  padding: "2px 7px",
                  boxShadow: "none",
                  color: "#345561",
                }}
                aria-label="Close"
                onClick={() => this.hideCommentsModal()}
              >
                <i className="fa fa-close" aria-hidden="true"></i>
              </Button>
            </div>
            <CommentsView appId={this.appId} key={"abc"} core={this.core} fileId={this.content.uuid} {...item} />
          </div>
        )}
        {this.state.dashList != undefined && this.state.dashList.length > 0 ? (
          <div id={filterPreview}>
            {oiStudio && !this.state.hideEdit && this.userProfile.key.privileges.MANAGE_DASHBOARD_WRITE && dashboardHeaderWithDropDown}
            <div className="dashboard-viewer-div" style={{ marginTop: !this.props.hideEdit ? "0px" : "-20px" }}>
              {this.state.uuid !== "" && (
                <DashboardViewer
                  customDashboardData={this.props.customDashboardData}
                  notif={this.props.notif}
                  appNavigationDiv={this.appNavigationDiv}
                  drilldownToDashboard={(e, type) => this.drilldownToDashboard(e, type)}
                  widgetFilter={this.content?.widgetFilter}
                  ref={(el) => (this.dashboardViewerRef = el)}
                  key={this.state.uuid}
                  uuid={this.state.uuid}
                  core={this.core}
                  proc={this.props.proc}
                  dashboardFilter={this.state.dashboardFilter}
                  appliedFilters={this.extractedFilters}
                  applyDashboardFilter={(filter) => this.applyDashboardFilter(filter)}
                  drilldownDashboardFilter={
                    this.state.drilldownDashboardFilter?.length >= 1
                      ? this.state.drilldownDashboardFilter
                      : this.props.content?.filter !== undefined
                      ? this.props.content.filter
                      : []
                  }
                  dashboardStack={this.state.dashboardStack}
                  dashboardStackDuplicate={this.state.dashboardStackDuplicate}
                  rollupToDashboard={() => this.rollupToDashboard()}
                  loadDefaultFilters={this.state.loadDefaultFilters}
                  appId={this.appId}
                />
              )}
            </div>
          </div>
        ) : (
          <div
            className="dashboard-viewer-div"
            style={{
              textAlign: "center",
              fontWeight: "bolder",
              fontSize: "20px",
            }}
          >
            {this.state.dashboardBody}
          </div>
        )}
      </>
    );
  };

  getBuilder = () => (
    <>
      <div id="dashboard-editor-div">
        {this.state.loadEditor && (
          <DashboardEditor
            proc={this.proc}
            userProfile={this.userProfile}
            args={this.core}
            notif={this.notif}
            setTitle={this.setTitle}
            key={this.state.uuid}
            dashboardId={this.state.uuid}
            linkedAppId={this.state.linkedAppId}
            flipCard={(status) => {
              if (status === "Saved") {
                // Refreshing the dashboardData
                this.fetchDashboards(true);
              } else if (status === "") {
                showDashboard(false);
              }
              this.setState({ isEditing: false, loadEditor: false });
            }}
          />
        )}
      </div>
    </>
  );

  render() {
    let dashboardView = "dashboard dashboard_" + this.state.uuid;
    return (
      <div ref={this.myRef} className={dashboardView}>
        <Notification ref={this.notif} />
        {/* this assumes that oi studio doesnt have an app ID and other apps have */}
        {!this.state.isEditing ? (!this.appId ? this.getViewer(true) : this.getViewer(false)) : this.getBuilder()}
        <DashboardEditorModal
          osjsCore={this.core}
          modalType={this.state.modalType}
          show={this.state.showModal}
          onHide={() => {
            this.setState({ showModal: false });
          }}
          content={this.state.modalContent}
          notification={this.notif}
          refreshDashboard={this.refreshDashboard}
          deleteDashboard={this.deleteDashboard}
        />
      </div>
    );
  }
}

export default DashboardManager;
export const { setShowFilter } = DashboardManager;

function FilterCount({ count }) {
  return (
    <div className="badgeInApps">
      <div className="badgeCheck filterInApps">{count}</div>
    </div>
  );
}
